import { CopyButton } from "./copy-button";

export const EmailSupport = ({
  emailAddress,
  emailAlternativeHint,
  message,
  messageContent,
}: {
  emailAddress: string;
  emailAlternativeHint?: React.ReactNode;
  message: string;
  messageContent?: React.ReactNode;
}) => (
  <div className="flex flex-col gap-4">
    <div className="flex gap-4 text-sm leading-tight items-center">
      <div className="p-4 bg-interstellar-3 rounded border border-gray justify-center items-start">
        {emailAddress}
      </div>
      {emailAlternativeHint}
    </div>
    <div className="mb-6">
      <CopyButton value="whiteglove@attentivemobile.com">Copy email</CopyButton>
    </div>
    <div className="p-4 bg-interstellar-3 rounded border border-gray justify-center items-start font-['TT Commons']">
      {messageContent || message}
    </div>
    <CopyButton value={message}>Copy text to clipboard</CopyButton>
  </div>
);
